const carrierServices = [
	'FedEx Ground',
	'FedEx Express',
	'UPS Ground',
	'UPS Express',
	'USPS Priority Mail Express',
	'USPS First Class Mail',
	'Priority DDP Delcon',
	'Amazon Transportation Ground',
];

export { carrierServices };



// WEBPACK FOOTER //
// ./src/common/constants/carrierServiceConstants.js